<template>
  <div id="duplicateButtonContainer">
    <button type="button" @click="$emit('addToJSON')">
      <p>{{ title}}</p>
      <i class="material-icons">add_circle</i>
    </button>
  </div>
</template>

<script>
import Vue from "vue";
import Vuelidate from "vuelidate";
import { required } from "vuelidate/lib/validators";
Vue.use(Vuelidate);

export default {
  name: "duplicate-previous-button",
  props: {
    id: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    value: {
      type: String,
      default: null
    },
    isHidden: {
      type: Boolean,
      default: null
    }
  },
  methods: {
    updateValue: function(value) {
      this.$emit("input", value);
    }
  }
};
</script>

<style lang="scss">
#duplicateButtonContainer {
  button {
    margin-top: 10px;
    margin-bottom: 20px;
    min-height: 40px;
    display: flex;
  }
  button:focus {
    background: none !important;
  }
  i {
    margin-left: 10px;
    color: #00bfb3;
  }
  p {
    margin: auto 0;
    color: #00bfb3;
  font-weight: 700;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fields/DuplicatePreviousButton.vue